import { LOCALES, LOCALE_NAMES, useLocale, useSetLocale, useT } from "../i18n";
import { useSession } from "../session";

/**
 * LanguageSwitch is the interface language as two side-by-side buttons: one
 * tap, no menu to open, and both options always visible (ADR-0023).
 *
 * Each language is named in itself and marked with its own `lang`, so someone
 * who cannot read the current interface can still find their language in it.
 *
 * Disabled until the session has answered. A tap before then cannot know
 * whether there is an account to save to, so it would land on the device only
 * — and a moment later the account's stored language would arrive and switch
 * the page straight back.
 */
export default function LanguageSwitch() {
  const t = useT();
  const locale = useLocale();
  const setLocale = useSetLocale();
  const { isPending } = useSession();
  return (
    <div
      role="group"
      aria-label={t.common.language}
      data-testid="language-switch"
      className="grid grid-cols-2 gap-1 rounded-control bg-sunk p-1"
    >
      {LOCALES.map((option) => (
        <button
          key={option}
          type="button"
          lang={option}
          disabled={isPending}
          aria-pressed={locale === option}
          data-testid={`language-${option}`}
          onClick={() => setLocale(option)}
          className={`rounded-[0.55rem] px-3 py-1.5 text-sm transition-colors disabled:opacity-50 ${
            locale === option ? "bg-surface font-medium text-ink" : "text-muted hover:text-ink"
          }`}
        >
          {LOCALE_NAMES[option]}
        </button>
      ))}
    </div>
  );
}
